import { Skeleton } from "../ui/skeleton";

export default function AutoStackTransactionHistorySkeleton() {
  return (
    <div className="bg-white rounded-2xl p-6 border border-bg-section w-full">
      {/* Header with title and Stack more button */}
      <div className="flex items-center justify-between mb-6">
        <Skeleton className="h-6 w-40 bg-gray-300" />
        <Skeleton className="h-9 w-28 rounded-full bg-gray-300" />
      </div>

      {/* Transaction items skeleton */}
      <div className="space-y-4">
        {Array.from({ length: 4 }).map((_, index) => (
          <div
            key={index}
            className="flex items-center justify-between border border-bg-section p-4 rounded-lg"
          >
            <div className="flex items-center gap-4">
              <Skeleton className="w-10 h-10 rounded-full bg-gray-300" />
              <div className="space-y-2">
                <Skeleton className="h-4 w-24 bg-gray-300" />
                <Skeleton className="h-3 w-20 bg-gray-300" />
              </div>
            </div>
            <div className="text-right space-y-2">
              <Skeleton className="h-4 w-16 bg-gray-300" />
              <Skeleton className="h-5 w-20 rounded-full bg-gray-300" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
